import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTwoBoxesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  justify-content: flex-start;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
  }
`;

export const StyledBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  padding: 2.4rem 1.8rem 0 1.8rem;
  justify-content: flex-start;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 4.6rem;
  }
`;

export const StyledBoxContainer = styled.div`
  background: linear-gradient(
    179deg,
    ${({ theme }) => theme.colors.roomProgressBar.first} 72.84%,
    ${({ theme }) => theme.colors.roomProgressBar.second} 145.61%,
    ${({ theme }) => theme.colors.roomProgressBar.third} 188.82%
  );
  border-radius: 1rem;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 50%;
  }
`;

export const StyledHeader = styled.span`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.grey[100]};
`;

export const StyledTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.grey[100]};
`;

export const StyledDivider = styled.div`
  height: 0.4rem;
  width: 15rem;
  border-radius: 0.2rem;
  background-color: ${({ theme }) => theme.colors.primary.main};
  margin-top: 0.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 1rem;
  }
`;

export const StyledDescription = styled.span`
  margin-top: 0.8rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.grey[200]};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 2rem;
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  margin-top: 1.4rem;
`;

export const StyledButton = styled(Button)`
  && {
    &&:hover {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const StyledImage = styled.img<{ hasWrapper?: boolean }>`
  margin-bottom: ${({ hasWrapper }) => (hasWrapper ? '0' : '1.7rem')};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding-right: ${({ hasWrapper }) => (hasWrapper ? '0' : '3.1rem')};
  }
`;

export const StyledImageWrapper = styled.div`
  display: flex;
  height: 18rem;
  margin-top: 1.3rem;
  justify-content: center;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: -8.2rem;
    display: flex;
    justify-content: flex-end;
  }
`;
